import {createHtmlElement, restrictUserInteractions, setCSSVar} from '../../../functions';
import { changeLangToCurrent, getCurrentLangDirection} from '../langSwitcher/langSwitcher';
import gsap from 'gsap';
import {
    changeFormTitle,
    changePlaceholder,
    moveFormToBlock,
    setPropId,
    setTranslateToSendBtn,
} from '../form/form';
import { chatsApplyNow } from '../apply-now/applyNow';
import { applyNowContent } from '../apply-now/applyNowContent';
import TextPlugin from 'gsap/TextPlugin';
import {components, isDesktop, isMobile, isNoMenu, settingsData, UIRoot} from '../../../settings';
import { analytics } from '../../analytics/analytics';
import {preventMenuWidthAnimation, toggleMenuWidth} from '../../menu/menu';
import { PopUp, PopUpPage } from '../../interfaces/pages/PopUp';
import {BaseElement} from "../../interfaces/BaseElement";
import { McID } from '../../menu/contactUs/McID';
import { Cookie } from '../../Cookie/Cookie';

export function chatsInit () {
    if (isDesktop && !settingsData.isConferenceHost || isNoMenu) return;

    let parent;

    if (settingsData.isConferenceHost && !isDesktop){
        if (isMobile) {
            parent = UIRoot;
        } else {
            parent = document.querySelector('.aside__bottom__container');
        }
    } else if (settingsData.isConferenceHost && isDesktop || isDesktop) {
        parent = document.querySelector('.aside__container');
    } else if (isMobile) {
        parent = UIRoot;
    } else {
        parent = document.querySelector('.aside__bottom__container');
    }

    components.contactWidget = new ContactWidget(parent);
    
    if (McID.active && !isDesktop) {
        if (!config.contactWidget.active && !settingsData.isConferenceHost) return;
        
        const logoImage = document.querySelector('.mc-id__logo');
        const logoWrapper = document.querySelector('.mc-id__logo-wrapper');
        const anchor = new BaseElement()
            .addClass('mc_id__consolto-anchor')
            .appendTo(logoWrapper)
            .DOMElement;
        const status = document.querySelector('.mc-id__consolto-status');
        status.style.display = 'none';

        components.contactWidget.onFlyEnd = () => {
          status.style.display = '';
          logoImage.classList.remove('invisible');
          anchor.remove();
        };
        components.contactWidget.container = anchor;
        components.contactWidget.showFormAnimation = false;
        components.contactWidget.createClone(logoImage);
        components.contactWidget.dropDownClone.classList.remove('hidden');
        logoImage.classList.add('invisible');
        components.contactWidget.createTextAndShowWidget();
        
        McID.addNewButton(components.contactWidget.createOptionButton(),'mc-menu');
    } else {
        components.contactWidget.create();
    }
}

export function contactFormChangeLanguage () {
    if (components.contactWidget)
        components.contactWidget.changeLanguage();
}

export function contactToAgentWithWidget (propId) {
    if (components.contactWidget)
        components.contactWidget.contactToAgent(undefined,propId);
}

export function closeContactWidget () {
    if (components.contactWidget)
        components.contactWidget.close();

    PopUpPage.hide();
}


export class ContactWidget {
    #formUsed = ['.contact-us','.apply__main-container:not(.chats)'];
    #defaultAgentName = {
        en: 'Bridget',
        he: "ברידג'ט",
        ru: 'Бриджит'
    };
    #video

    constructor (parent, animation = true) {
        this.parent = parent;
        this.animation = animation;
        this.container = null;
        this.widgetBtn = null;
        this.closeBtn = null;
        this.contentContainer = null;
        this.form = null;
        this.opened = false;
        this.showFormAnimation = true;
        this.consoltoIsActive = settingsData.isConferenceHost || config?.consolto?.active;
        this.consoltoWidget = null;
        this.agentStatus = 'offline';
        this.agentElement = null;
        this.cloneBtn = null;
        this.dropDownClone = null;
        this.applyNow = null;
        this.activeContent = null;
        this.blockEvents = false;
        this.formUse = true;
        this.onFlyEnd = () => {};
        this.imageAgentUrl = config.contactWidget?.agentImageUrl || '../img/online.png';
        this.#video = config.features.contactWidget?.video?.active && config.features.contactWidget?.video?.url;
    }

    async create () {
        if (!config.contactWidget.active && !settingsData.isConferenceHost) return;

        this.container = createHtmlElement('', '', 'div', ['contact-widget__main-container', 'invisible']);
        this.parent.insertAdjacentElement('afterbegin',this.container);
        this.widgetBtn = createHtmlElement(
          this.container,
          '',
          'div',
          ['contact-widget__btn', 'background-backdrop-filter']
        );
        document.documentElement.style.setProperty('--image-agent-url', `url(\'${this.imageAgentUrl}\')`);
        const text = createHtmlElement(this.widgetBtn,changeLangToCurrent('Lets talk'),'span',['language-string']);
        text.setAttribute('data-dictionary','Lets talk');

        // if (!isMobile){
            // this.widgetBtn.classList.add('language-string');
            // this.widgetBtn.setAttribute('data-dictionary','Lets talk');
        // }

        if (this.consoltoIsActive) {
            const consoltoScript = createHtmlElement(document.body, '', 'script', []);
            consoltoScript.setAttribute('id', 'et-iframe');
            consoltoScript.setAttribute('data-version', '0.5');

            if (settingsData.isConferenceHost){
                consoltoScript.setAttribute('data-widgetId', config.features.contactWidget.consolto.id);
            } else {
                consoltoScript.setAttribute('data-widgetId', config?.consolto.id);
            }

            consoltoScript.setAttribute('src', 'https://client.consolto.com/iframeApp/iframeApp.js');
            this.widgetBtn.classList.add('consolto');

            window.addEventListener('consoltoEvent', this.addConsoltoEventListener.bind(this));
        }

        this.contentContainer = createHtmlElement(this.container, '', 'div', ['contact-widget__content__container', 'hidden']);
        this.closeBtn = createHtmlElement(this.contentContainer, '', 'div', ['contact-widget__close__btn', 'icon-close']);

        this.closeBtn.addEventListener('click', this.close.bind(this));
        this.widgetBtn.addEventListener('click', this.contactToAgent.bind(this));

        this.cloneBtn = this.widgetBtn.cloneNode(true);
        this.cloneBtn.classList.add('clone');
        this.cloneBtn.textContent = '';

        if (isMobile){
            this.cloneBtn.classList.add('normal__size');
        }

        // this.dropDownClone = this.widgetBtn.cloneNode(true);
        // this.dropDownClone.classList.add('drop-down__clone');
        // this.dropDownClone.textContent = '';
        // const dropDownText = createHtmlElement(this.dropDownClone,'','span',['drop-down__text','hidden']);
        //
        // if (this.#video) {
        //     dropDownText.style.paddingBottom = '140px';
        //     this.#addVideoToTheWidget();
        // }
        this.createClone();

        if (this.formUse){
            this.form = createHtmlElement(this.contentContainer,'','div',['chats__form']);
            this.form.insertAdjacentElement('afterbegin',this.cloneBtn);
            this.form.classList.add('hidden');
        }

        this.applyNow = chatsApplyNow(this.contentContainer, applyNowContent);
        this.applyNow.insertAdjacentElement('afterbegin',this.cloneBtn.cloneNode(true));
        
        // const showDate = Cookie.getCookie('contactWidgetShowDate');
        // let text;
        // const agentNames = { agentName: {} };
        //
        // config.contactWidget.agentName.forEach(name => {
        //     if (name.value) {
        //         agentNames.agentName[name.lang] = name.value;
        //     } else {
        //         agentNames.agentName[name.lang] = this.#defaultAgentName[name.lang];
        //     }
        // });
        //
        // if (!showDate){
        //     Cookie.setCookie('contactWidgetShowDate',Date.now());
        //     text = changeLangToCurrent('contactWidgetWelcomeText',[agentNames]);
        // } else {
        //     const dateFrom = Number(showDate);
        //     const expiredDate = dateFrom + 2629800000;
        //
        //     if (Date.now() > expiredDate){
        //         text = changeLangToCurrent('contactWidgetWelcomeText',[agentNames]);
        //     } else {
        //         text = changeLangToCurrent('contactWelcomeText2');
        //     }
        // }
        // this.showWidget(text);
        this.createTextAndShowWidget();
    }
    
    createClone(element) {
        this.dropDownClone = element ? element.cloneNode(true) : this.widgetBtn.cloneNode(true);
        this.dropDownClone.classList.add('drop-down__clone');
        this.dropDownClone.textContent = '';
        const dropDownText = createHtmlElement(this.dropDownClone,'','span',['drop-down__text','hidden']);
    
        if (this.#video) {
            dropDownText.style.paddingBottom = '140px';
            this.#addVideoToTheWidget();
        }
    }
    
    createTextAndShowWidget() {
        const showDate = Cookie.getCookie('contactWidgetShowDate');
        let text;
        const agentNames = { agentName: {} };
    
        config.contactWidget.agentName.forEach(name => {
            if (name.value) {
                agentNames.agentName[name.lang] = name.value;
            } else {
                agentNames.agentName[name.lang] = this.#defaultAgentName[name.lang];
            }
        });
    
        if (!showDate){
            Cookie.setCookie('contactWidgetShowDate',Date.now());
            text = changeLangToCurrent('contactWidgetWelcomeText',[agentNames]);
        } else {
            const dateFrom = Number(showDate);
            const expiredDate = dateFrom + 2629800000;
        
            if (Date.now() > expiredDate){
                text = changeLangToCurrent('contactWidgetWelcomeText',[agentNames]);
            } else {
                text = changeLangToCurrent('contactWelcomeText2');
            }
        }
        this.showWidget(text);
    }
    
    createOptionButton() {
        if (!config.contactWidget.active && !settingsData.isConferenceHost) return;
       
        const widgetBtn = createHtmlElement(
            '',
            changeLangToCurrent('Lets talk'),
            'div',
            ['mc-id__contact-widget__btn','language-string','icon-video-call']
        );
        widgetBtn.setAttribute('data-dictionary','Lets talk');
        widgetBtn.setAttribute('data-role','consolto');
        
        if (this.consoltoIsActive) {
            const consoltoScript = createHtmlElement(document.body, '', 'script', []);
            consoltoScript.setAttribute('id', 'et-iframe');
            consoltoScript.setAttribute('data-version', '0.5');
        
            if (settingsData.isConferenceHost) {
                consoltoScript.setAttribute('data-widgetId', config.features.contactWidget.consolto.id);
            } else {
                consoltoScript.setAttribute('data-widgetId', config?.consolto.id);
            }
        
            consoltoScript.setAttribute('src', 'https://client.consolto.com/iframeApp/iframeApp.js');
            window.addEventListener('consoltoEvent', this.addConsoltoEventListener.bind(this));
        }
    
        const popUp = new PopUp({
            id: 'consolto-form',
            needsCloseBtn: true,
            destroy: false
        });
        
        popUp.onClose = () => {
            popUp.hide();
            setTimeout(() => {
                this.close();
            },300);
        };
    
        this.contentContainer = createHtmlElement(popUp.content, '', 'div', ['contact-widget__content__container','mc-id__contact-widget__content__container', 'hidden']);
        // this.closeBtn = createHtmlElement(this.contentContainer, '', 'div', ['contact-widget__close__btn', 'icon-close']);
        // this.closeBtn.addEventListener('click', this.close.bind(this));
    
        new BaseElement()
            .addClass('mc-id__logo','mc-id__logo-form')
            .appendTo(this.contentContainer)
            .DOMElement;
    
        widgetBtn.addEventListener('click', (e) => {
            // if (!this.isFormSend()) {
            //     popUp.show();
            // }
            this.contactToAgent(e);
        });
    
        if (this.formUse){
            this.form = createHtmlElement(this.contentContainer,'','div',['chats__form']);
            this.form.classList.add('hidden');
        }
    
        this.applyNow = chatsApplyNow(this.contentContainer, applyNowContent);
        
        return widgetBtn;
    }

    getForm(propId){
        let activeElement = false;

        this.#formUsed.forEach(query => {
           const form = document.querySelector(query)?.querySelector('.form__container-main');

           if (form) {
               activeElement = query;
           }
        });

        switch (activeElement) {
            case '.contact-us':
                // removeContactUs();
                moveFormToBlock(this.form);

                break;

            case '.apply__main-container:not(.chats)':
                moveFormToBlock(this.form);
                const applyContainer = document.querySelector('.apply__main-container:not(.chats)');
                applyContainer.remove();
                break;

            default:
                moveFormToBlock(this.form);

                break;

        }

        this.#customiseForm(propId);
    }

    addConsoltoEventListener (e) {
        if (e.detail.consoltoReady) {
            this.consoltoWidget = new CustomEvent('consolto_h2w', {
                detail: {
                    'et-click-type': 'open-widget',
                    'et-agent-id': config.features.contactWidget?.consolto?.agentId || '',
                },
            });
        }
        
        const iframe = document.querySelector('#expertips_iframe');

        if (e.detail?.action === 'AVAILABILITY_STATE_CHANGE') {
            this.changeAgentStatus(e.detail.value);
            this.changeButtonTitle();

            if (iframe && e.detail?.value === 'offline') {
                iframe.style.display = 'none';
                iframe.classList.add('hidden');
            }
        }

        if (e.detail?.action === 'OPEN_WIDGET'){
            this.btnVisibleToggle('hide');
            if (iframe) {
                iframe.style.display = 'block';
                iframe.classList.remove('hidden');
            }
        }
        
        if (e.detail?.action === 'CLOSE_ACCOUNT_WIDGET' || e.detail?.action === 'CLOSE_WIDGET') {
            preventMenuWidthAnimation(false);
            toggleMenuWidth({action: 'mini', source: 'eventListener'});
            this.btnVisibleToggle('show');
            if (iframe) {
                iframe.style.display = 'none';
                iframe.classList.add('hidden');
            }
        }

        if (e.detail?.action === 'CALL_STARTED_CLIENT'){
            analytics('call_start');
        }

    }

    changeAgentStatus (status) {
        this.agentStatus = status;
        
        if (McID.active) {
            McID.updateConsoltoStatus(status);
        } else {
            if (isMobile){
                this.cloneBtn.className = `contact-widget__btn consolto clone normal__size ${status}`;
                this.widgetBtn.className = `contact-widget__btn consolto ${status}`;
            } else {
                this.cloneBtn.className = `contact-widget__btn consolto clone ${status}`;
                this.widgetBtn.className = `contact-widget__btn language-string consolto ${status}`;
            }
        }
    }

    changeButtonTitle() {
        if (isMobile || McID.active)
            return;

        switch (this.agentStatus) {
            case 'offline':
                this.widgetBtn.innerHTML = changeLangToCurrent('contactUs');
                this.widgetBtn.setAttribute('data-dictionary','contactUs');
                break;
            case 'available':
                this.widgetBtn.innerHTML = changeLangToCurrent('Lets talk');
                this.widgetBtn.setAttribute('data-dictionary','Lets talk');
                break;
            default:
                console.log('ContactWidget:ChangeButtonTitle:Default case triggered');
                break;
        }
    }

    btnVisibleToggle(action){
        if (McID.active) return;
        switch (action) {
            case 'show':
                this.widgetBtn.style.visibility = 'visible';
                break;
            case 'hide':
                this.widgetBtn.style.visibility = 'hidden';
                break;
        }
    }

    #customiseForm(propId){
        if (!config.general.leadForm && !settingsData.isConferenceHost)  return;

        this.form.querySelector('input[type="email"]').parentElement.classList.add('hidden');

        if (propId){
            setPropId(this.form, propId);
        }
    
        changeFormTitle('Lets talk');
    }

    contactToAgent (e,propId) {
        if (e?.target?.classList?.contains('contact-widget__btn') && this.opened){
            return;
        }

        if (this.consoltoIsActive) {

            // if (this.isFormSend()){
            //
            //     if (this.opened){
            //         const popup = PopUp.getScope('consolto-form');
            //         if (popup) {
            //             popup.hide();
            //         } else {
            //             this.close();
            //         }
            //     }
            //
                this.openConsoltoWidget();
            //
            // } else {
            //
            //     if (this.formUse) {
            //         this.getForm(propId);
            //         this.activeContent = this.form;
            //         this.open();
            //     } else {
            //         this.openConsoltoWidget();
            //     }
            // }

            /*switch (this.agentStatus) {
                case 'offline':

                    if (this.opened) {
                        this.showApplyNow();

                    } else {

                        if (this.isFormSend()) {
                            this.activeContent = this.applyNow;
                            this.open();
                        } else {
                            this.activeContent = this.form;
                            this.open();
                        }
                    }
                    break;

                case 'available':

                    if (this.isFormSend()){

                        if (this.opened){
                            this.close();
                        }

                        this.openConsoltoWidget();

                    } else {

                       if (this.opened){
                           this.openConsoltoWidget();
                       } else {
                           this.activeContent = this.form;
                           this.open();
                       }

                    }
                    break;

                case 'busy':

                    if (this.opened) {
                        this.showApplyNow();

                    } else {

                        if (this.isFormSend()) {
                            this.activeContent = this.applyNow;
                            this.open();
                        } else {
                            this.activeContent = this.form;
                            this.open();
                        }
                    }
                    break;

            }*/

        } else {

            if (this.isFormSend()) {
                if (this.opened){
                    this.showApplyNow();
                } else {
                    this.activeContent = this.applyNow;
                    this.open();
                }
            } else {

                if (this.formUse){
                    this.getForm(propId);
                    this.activeContent = this.form;
                } else {
                    this.activeContent = this.applyNow;
                }
                this.open();
            }
        }

        preventMenuWidthAnimation(true);
    }

    openConsoltoWidget () {
        window.dispatchEvent(this.consoltoWidget);
    }

    showApplyNow () {
        if (this.activeContent === this.applyNow) return;

        const tl = gsap.timeline({
            onComplete: () => {
                this.activeContent = this.applyNow;
            },
        });

        if (this.widgetBtn.style.visibility === 'hidden'){
            this.widgetBtn.style.visibility = 'visible';
        }


        tl.fromTo(this.form, {
            transform: 'rotateY(0)',
        }, {
            transform: 'rotateY(90deg)',
            duration: .2,
            onComplete: () => {
                this.form.classList.add('hidden');
                this.applyNow.classList.remove('hidden');

                tl.fromTo(this.applyNow, {
                    transform: 'rotateY(-90deg)',
                }, {
                    transform: 'rotateY(0)',
                    duration: .2,
                });
            },
        });
    }

    open () {
        if (this.opened) return;
        if (this.blockEvents) return;
        
        this.resetStyle();

        this.activeContent.classList.remove('hidden');
        this.contentContainer.classList.remove('hidden');

        // tl.fromTo(this.contentContainer, {
        //     height: 0,
        // }, {
        //     height: 'auto',
        //     duration: .5,
        //     onStart: () => {
        //         if (this.activeContent === this.form){
        //             this.widgetBtn.style.visibility = 'hidden';
        //         }
        //         this.contentContainer.style.padding = '';
        //     },
        // });
    
        if (this.showFormAnimation) {
            this.blockEvents = true;
            const tl = gsap.timeline({
                onComplete: () => {
                    this.opened = true;
                    this.blockEvents = false;
                },
            });
    
            tl.fromTo(this.contentContainer, {
                transform: `translate(50%, 50%) scale(0)`
            }, {
                transform: `translate(0) scale(1)`,
                duration: .5,
                onStart: () => {
                    this.btnVisibleToggle('hide');
                    this.contentContainer.style.padding = '';
                },
            });
    
    
            tl.fromTo([this.activeContent, this.closeBtn], {
                opacity: 0,
            }, {
                opacity: 1,
                duration: .8,
            });
        } else {
            this.opened = true;
        }
    }

    resetStyle () {
        this.applyNow.classList.add('hidden');
        this.applyNow.style.opacity = '';
        this.applyNow.style.transform = '';

        if (this.formUse){
            this.form.classList.add('hidden');
            this.form.style.opacity = '';
            this.form.style.transform = '';
        }

        this.contentContainer.style.transform = '';
        this.contentContainer.style.height = '';
    }

    close () {
        if (!this.opened || this.blockEvents) return;

        this.blockEvents = true;

        this.contentContainer.classList.add('hidden');
        this.opened = false;
        this.btnVisibleToggle('show');
        this.blockEvents = false;
        this.resetStyle();
        preventMenuWidthAnimation(false);
    }

    isFormSend () {
        const sendDate = Cookie.getCookie('contactFormSend');

        if (sendDate){
            const parseSendDate = Number(sendDate);
            const expiredDate = parseSendDate + 2629800000;

            return Date.now() <= expiredDate;

        } else {

            return false;
        }
    }

    changeLanguage () {
        if (!this.form)
            return;

        setTranslateToSendBtn(this.form);
        changePlaceholder(this.form);
    }

    showWidget (text) {
        if (!this.animation) {
            this.container.classList.remove('hidden','invisible');

            return;
        }

        const dir = getCurrentLangDirection();
        const side =  isDesktop || isMobile ? 0 : dir === 'rtl' ? -100 : 100;
        const avatarSize = isMobile ? 10 : 80;
        const topDropDown = isMobile ? settingsData.isLandscape ? 10 : 100 : 200;
        const diff = isMobile ? 8 : 5;
        const scale = isMobile ? 0.25 : 0.5;

        gsap.registerPlugin(TextPlugin);

        const tl = gsap.timeline();
            const closeBtn = new BaseElement()
            .addClass('drop-down__close-btn','icon-close','hidden')
            .appendTo(this.dropDownClone)
            .event('click',() => {
                tl.clear();
                this.#hideText(tl, 0);
                this.#flyToWidget(tl, avatarSize, diff, scale);
                closeBtn.addClass('hidden');
            });

        document.body.appendChild(this.dropDownClone);

        // Drop down
        tl.to(this.dropDownClone,{
            transform: `translate(${window.innerWidth / 2 + side}px, ${topDropDown}px)`,
            left: 0,
            top: 0,
            duration: .5
        });

        // Print
        tl.to(this.dropDownClone.querySelector('.drop-down__text'),{
            text: text,
            duration: Math.ceil(text.split(' ').length / 4),
            onStart: () => {
                this.dropDownClone.querySelector('.drop-down__text').classList.remove('hidden');
                closeBtn.removeClass('hidden');
            },
            onUpdate: () => {
                const textElement = this.dropDownClone.querySelector('.drop-down__text');
                const textElementHeight = textElement.getBoundingClientRect().height;
                const videoWrapperPosition = textElementHeight - 50;
                setCSSVar('--videoWrapperPosition', `${videoWrapperPosition}px`);
            }
        });

        this.#hideText(tl);
        this.#flyToWidget(tl, avatarSize, diff, scale);
    }

    positionRecalc() {
        if (this.dropDownClone) {
            const dir = getCurrentLangDirection();
            const side =  isDesktop || isMobile ? 0 : dir === 'rtl' ? -100 : 100;
            const topDropDown = isMobile ? settingsData.isLandscape ? 10 : 100 : 200;
    
            gsap.to(this.dropDownClone,{
                transform: `translate(${window.innerWidth / 2 + side}px, ${topDropDown}px)`,
                left: 0,
                top: 0,
                duration: .5
            });
        }
    }

    #flyToWidget(tl, avatarSize, diff, scale) {
        tl.to(this.dropDownClone, {
            transform: () => {
                const containerPosition = this.container.getBoundingClientRect();
                const asideContainer = document.querySelector('.aside__container');
                if (asideContainer.classList.contains('minimized')) {
                    avatarSize = 40;
                }
                return `translate(${containerPosition.x + avatarSize + diff}px,${containerPosition.y - avatarSize + diff}px) scale(${scale})`;
            },
            duration: 1,
            onComplete: () => {
                this.container.classList.remove('hidden','invisible');
                this.dropDownClone.remove();
                this.dropDownClone = null;
                this.onFlyEnd();

                restrictUserInteractions(false);
            },
            onStart: () => {
                if (this.#video)
                    this.#removeVideoFromWidget();
    
                this.dropDownClone.querySelector('.drop-down__close-btn').classList.add('hidden');
            }
        })
    }

    #hideText(tl, delay = 2.5) {
        tl.to(this.dropDownClone.querySelector('.drop-down__text'),{
            opacity: 0,
            duration: .2,
            delay: delay,
            onComplete: () => this.dropDownClone.querySelector('.drop-down__text').classList.add('hidden')
        });
    }

    #addVideoToTheWidget() {
        const videoWrapperElement = new BaseElement()
            .addClass('drop-down__video-wrapper')
            .event('click', videoWrapperClickHandler, {once: true})
            .appendTo(this.dropDownClone);
        const placeholder = new BaseElement('img')
            .addClass('video-placeholder')
            .appendTo(videoWrapperElement.DOMElement);
        placeholder.DOMElement.src = config.features.contactWidget?.video?.placeholder;
        const playIcon = new BaseElement()
            .addClass('playpause', 'icon-play')
            .appendTo(videoWrapperElement.DOMElement);

        const videoElement = new BaseElement('video')
            .addClass('drop-down__video')
            .appendTo(videoWrapperElement.DOMElement);
        videoElement.DOMElement.controls = true;
        videoElement.DOMElement.autoplay = false;
        videoElement.DOMElement.muted = false;
        videoElement.DOMElement.allowfullscreen = true;

        const videoSource = new BaseElement('source')
            .appendTo(videoElement.DOMElement);
        videoSource.DOMElement.src = this.#video;
        videoSource.DOMElement.type = `video/mp4`;

        function videoWrapperClickHandler() {
            placeholder.remove();
            playIcon.remove();
            const asideContainer = document.querySelector('.aside__container');
            const offset = asideContainer.getAttribute('data-initial-width');
            const videoPopUp = new PopUpPage('');
            videoPopUp.addClass('widget-video');
            videoPopUp.contentElement.appendChild(videoWrapperElement.DOMElement);
            videoPopUp.root.style.width = `calc(100% - ${offset}px`;
            // videoElement.DOMElement.controls = true;
            videoElement.DOMElement.pause();
        }
    }

    #removeVideoFromWidget() {
        const videoWrapper = this.dropDownClone.querySelector('.drop-down__video-wrapper');
        if (videoWrapper)
            videoWrapper.remove();
    }
}
